import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";

export const AnimatedNumber = ({ value, format = (n) => n, duration = 1.6 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-30px" });
  const [n, setN] = useState(null);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, { duration, ease: [0.22, 1, 0.36, 1], onUpdate: (v) => setN(v) });
    return () => controls.stop();
  }, [inView, value, duration]);

  return <span ref={ref}>{format(n === null ? value : Math.round(n))}</span>;
};
